export default function FormsDetails() {
  return (
    <div>
      <div className="calhoun-street-bridge-bg bg-image">
        <div className="gap-spacer"></div>
        <div className="page-title top-cap-outlines">
          <h2>Forms</h2>
        </div>

        {/*End Large Image Space*/}
        {/*Start Main Content*/}
        <div className="content">
          <div className="mb-960-center-column mid-side-outlines">
            <p>
            <h3>Code Enforcement</h3>
                <a href="./docs/code/Residential-Rental-License-Permit-Registration.pdf" target="_blank" rel="noopener noreferrer">
                  &nbsp;
                  <i className="fa-solid fa-file-pdf fa-lg"></i>
                  &nbsp;Residential Rental License Permit Registration{" "}
                </a>{" "}
            </p>
            <br/>
             <p>
            <h3>Employment</h3>
            
               <a href="../docs/employment/Borough-of-Morrisville-Employment-Application.pdf" target="_blank" rel="noopener noreferrer">
                                        <i className="fa-solid fa-file-pdf fa-xl"></i>&nbsp;
                                        Non-Police Employment Application</a>
            </p>
            <br/>
            <p>
            <h3>Police</h3>
           
                <a href="../docs/police/Citizen-Complaint-Form.pdf" target="_blank" rel="noopener noreferrer">
						<i className="fa-solid fa-file-pdf fa-xl"></i>&nbsp;
						Citizen Complaint Form</a>
            </p>
            <br/>
            <p>
             <h3>Right To Know</h3>
            
                <a href="../docs/rtk/PA-RTKRequestForm.pdf" target="_blank" rel="noopener noreferrer">
                <i className="fa-solid fa-file-pdf fa-xl"></i>&nbsp;PA Right To Know Request Form</a>
              
            </p>
          </div>
          <div className="page-footer bottom-cap-outlines">&nbsp;</div>
        </div>
      </div>
    </div>
  );
}
